var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 14,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 13,
    height: 13.001,
    transform: "rotate(90 13 0)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 13,
    height: 13.001,
    transform: "rotate(90 13 0)",
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0151515 0.0149254)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 66,
    height: 67,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABDCAYAAAAoCNNNAAAABHNCSVQICAgIfAhkiAAAA39JREFUeF7tmkeW1TAQRd+HZRCauA9g2hsg5zQiTFgEA0KPyDmOmQP7IIdtwOc8jsSR3bJVkksyg9Kkz/n2t6Xr916V/HuxXC4x49gPYBXAAsAbAK/nmstiRhCE8AzARrf4XwAOA3g1B4y5QBwHcC+A4NdOGKcBPGoNYw4QBwC8SCz0IICXLWG0BsEFPokoob9mKuNISxgtQUghhDY5KlCPinBagTgE4LFACTFlHAPwXGW1IxdpAaIUQqiM6jBqg2A5ZAXwJbL0wTIzqsKoCUILQqgMll32HuqjFggm/kMFJcQy4wSAp9okaoCoBSFUhjoMbRAsdw8qKCGmjJOuJ1ERhyaIVhBCZajB0ALBRL8vVMI3ACuJxyg5h5dgNTnlepRJytAAkQthD4AviVnvAPBOAEwNxlQQQ7vI2Dr5lAnhK4DUSxC+n9gG4H0GjEm71ikgciBw8XsdBEKSgOB5hEFl8G9qTNrCl4Jg+borzIQ+hBwQJTDOuB4mBa5zvATEVAi5IJrAyAVBCHyztEGAm0pgJjAb+kNqjfB7rDTMDIlNfrs3XexuRSMHRA4EVgVmQgxCiSL8YgiDmbFdsDrCoE3Y4CWHFAQbF2aCRAkpCFNA8LtVYEhAaEOYCqIKjBQIQmAmsK6nBpXATPieOjGjfI5daqvLDIlNmEnsMwZtMgYiB8JnlwkSCBqK8IAIg5nBTjQ1CIOZwa3AujEEgv07M0GihFwImiB4rVwYZ53KOzBiICihOxUhaINQgdEHkQuBmfAjpcnI8ZI+InWbLS4zpDbpKCMEQf/czlBCKYQaivCQCIOZsTNFzQX2ORcB8CByIHxywViiBD+/GooohXGeUUAQlMgtoRI0INRURDEMgrgB4KJASoRAO/wUnJs6paYi/L03u8yQ2GSNIFgiCePCyOw1IbRQRAiDmbFrZG1rAC75jBiD8dFlgoYSWmREf81UxhCMvxAYnGHVIIzrPZt8ALBPyQ7hBFtYI7wfYbwFsDv48B8EftbvIwjjmqNUC0JLawzBuAngcrjniXWWhHHF/RSvaYc5FeHvvcn9n9bV/sYvtftMpX/p8dbWSM7TQDhEBsJAdN1iijBFmCKiFcSsYdYwa5g1xtpLywjLCMsIywjLiOQmfP0bKsFXVE6x9xEOo4EwEF1HmSJMEaaIaJUxa5g1zBpmjbEW1DLCMuI/z4g/bu+tguyc0oAAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.0df9c4ee936e671fb1ea0d04ccd440f0.svg";
export { ForwardRef as ReactComponent };